/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo, useCallback } from 'react';
import { appStatuses } from 'constants';

const defaultAppTypeFilter = {
  name: 'All Application Types',
  id: 'all_types',
};

const checkName = (name, search) => {
  return name?.toLowerCase().includes(search.toLowerCase());
};

const checkPba_Number = (number, search) => {
  return number.toString().startsWith(search);
};

const matchAppName = (search) => {
  return ({ pba_name, pba_number, pba_url1, pba_url }) =>
    checkName(pba_name, search) ||
    checkPba_Number(pba_number, search) ||
    checkName(pba_url1, search) ||
    checkName(pba_url, search);
};

export const useFacade = (appList = [], isPublisher = false) => {
  //const [listApps, setListApps] = useState(appList);
  const [searchValue, setSearchValue] = useState('');
  const [filterState, setFilterState] = useState({
    name: 'All But Archived',
    id: 'all_but_archived',
  });
  const [appTypeFilter, setAppTypeFilter] = useState(defaultAppTypeFilter);

  const handleInputSearchValue = useCallback((e) => {
    setSearchValue((e.target.value || '').trim());
  }, []);

  useEffect(() => {
    if (isPublisher && appTypeFilter.id !== defaultAppTypeFilter.id) {
      setAppTypeFilter(defaultAppTypeFilter);
    }
  }, [appTypeFilter.id, isPublisher]);

  const filtededApps = useMemo(() => {
    const currentStatus = filterState.id;
    if (currentStatus === appStatuses.all_statuses) return appList;
    if (currentStatus === appStatuses.all_but_archived)
      return appList.filter((app) => app.status !== appStatuses.archived);
    return appList.filter((app) => app.status === currentStatus);
  }, [filterState.id, appList]);

  const filteredByAppType = useMemo(() => {
    if (isPublisher) return filtededApps;
    if (appTypeFilter.id === 'all_types') return filtededApps;
    if (appTypeFilter.id === 'websites') return filtededApps.filter((app) => !!app.app_type_assoc);
    return filtededApps.filter((app) => !app.app_type_assoc);
  }, [appTypeFilter.id, filtededApps, isPublisher]);

  const foundedApps = useMemo(() => {
    if (!searchValue) return filteredByAppType;
    const matcher = matchAppName(searchValue);
    return filteredByAppType.filter(matcher);
  }, [searchValue, filteredByAppType]);

  // const foundedApps = useMemo(() => {
  //   const currentStatus = filterState.id;
  //   const matcher = matchAppName(searchValue);
  //   if (currentStatus === appStatuses.all_statuses) return listApps.filter(matcher);
  //   if (currentStatus === appStatuses.all_but_archived)
  //     return listApps.filter((app) => app.status !== appStatuses.archived).filter(matcher);
  //   return listApps.filter((app) => app.status === currentStatus).filter(matcher);
  // }, [searchValue, listApps, filterState]);

  return {
    foundedApps,
    searchValue,
    handleInputSearchValue,
    setSearchValue,
    setFilterState,
    filterState,
    appTypeFilter,
    setAppTypeFilter,
  };
};
